"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
const profileErrors = {
    lengthLimitName: () => i18next_1.default.t('닉네임은 8자 이하로 입력해주세요'),
    exceededProfile: () => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [`${i18next_1.default.t('프로필 부자!!')} ᵔᴗᵔ`, (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('프로필은 최대 3개까지 가질 수 있어요.')] })),
    noAuthority: () => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('잠깐! 회원님이 맞으신가요?'), (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('확인을 눌러주세요. 뿅')} ( ´•.•́ )✧`] })),
    dissonantProfile: () => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('잠깐! 프로필을 수정하기 전에,'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('최근에 사용한 프로필로 바꿔드릴게요.')] })),
    duplicateName: () => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('사용중인 닉네임이에요.'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('새로운 닉네임을 입력해주세요')] })),
    requiredName: () => i18next_1.default.t('닉네임을 입력해주세요'),
    patternName: () => i18next_1.default.t('유효하지 않은 닉네임이에요'),
    lengthLimitUid: () => i18next_1.default.t('영문 포함, 최소 4자 ~ 최대 15자 입력해주세요'),
    patternUid: () => i18next_1.default.t('유효하지 않은 아이디예요'),
    duplicateUid: () => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('사용중인 아이디예요.'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('새로운 아이디를 입력해주세요')] })),
    requiredUid: () => i18next_1.default.t('아이디를 입력해주세요'),
    noBFSpaceName: () => i18next_1.default.t('앞, 뒤 공백을 제거해주세요'),
    noConsonantName: () => i18next_1.default.t('단어를 완성해주세요'),
    notAllowedCharsUid: () => i18next_1.default.t('영문/숫자/하이픈(-)만 입력해주세요'),
    noMultiHyphenUid: () => i18next_1.default.t('하이픈(-)은 한 개만 입력해주세요'),
};
exports.default = profileErrors;
